import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from './hooks/UserContext';

const AdminRoute = ({ requiredRole }) => {
  const { user, loading, systemAdminRole } = useUser();

  if (loading) {
    return <div style={{ textAlign: 'center', marginTop: '50px' }}>Verifying session...</div>; 
  }

  if (user && user.systemadmin && user.systemAdminStatus !== 'disabled') {
    // Check OTP / 2FA session verification for system admin
    const isOtpVerified = sessionStorage.getItem('adminSessionVerified') === 'true';
    if (!isOtpVerified) {
      return <Navigate to="/admin/login" replace />;
    }

    if (requiredRole === 'admin') {
      if (systemAdminRole === 'admin') {
        return <Outlet />;
      } else {
        return <Navigate to="/admin" replace />;
      }
    }
    if (requiredRole === 'operator') {
      if (systemAdminRole === 'admin' || systemAdminRole === 'operator') {
        return <Outlet />;
      } else {
        return <Navigate to="/admin" replace />;
      }
    }
    return <Outlet />;
  }
  
  return <Navigate to="/admin/login" replace />;
};

export default AdminRoute;
